module.exports = __webpack_public_path__ + "img/leztroy-crm-logo.2f0f86df.png";